export enum StatelessQuotationTotalVariants {
  DEFAULT = 'DEFAULT',
  SELFCARE = 'SELFCARE',
}
